export const useIsPreviewWindow = () => {
  const isInsideIframe = window.self !== window.top;
  const isEditMode =
    isInsideIframe && window.location.search.includes('preview=true');

  return isEditMode;
};
